import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LoadingButton from '../components/LoadingButton'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import { employeeAdvancedSearchCols } from '../constants/EmployeeCols'
import useDateRangeCol from '../hooks/useDateRangeCol'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  }
}))

const defaultHeaders = {
  company: ''
}

export default function EmployeeAdvancedSearch(props) {
  const [state, setState] = useState({
    isLoading: false,
    fetched: true,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = useState(false)
  const [clearTrigger, setClearTrigger] = useState(false)
  const classes = useStyles()

  const birthdateCol = useDateRangeCol('BIRTHDATE', 'Birthdate')
  const tableColumns = employeeAdvancedSearchCols.map(col =>
    col.accessorKey === 'BIRTHDATE'
      ? { ...col, ...birthdateCol, enableColumnFilter: true, enableSorting: false }
      : col
  )

  const { credentials } = props.fetchInitialData

  const handleSubmit = e => {
    e.preventDefault()
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setState({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }

  const handleCallback = (values, error) => {
    if (error) {
      setState({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setState({ ...state, isLoading: false })
  }

  const tableDataTransformation = rows => {
    return rows.map(row => {
      return {
        ...row,
        EMPLOYEE: row.EMPLOYEE ? (
          <div
            className='editLink'
            onClick={() => {
              const url = `/employee?company=${encodeURIComponent(headers.company)}&employee=${encodeURIComponent(row.EMPLOYEE)}`
              const win = window.open(url, '_blank')
              win.focus()
            }}
            style={{ cursor: 'pointer' }}
          >
            {row.EMPLOYEE}
          </div>
        ) : ''
      }
    })
  }

  if (!state.fetched) {
    return <LoadingCircle />
  }

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='back'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Employee Advanced Search
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='250px'
                  label='Company'
                  page="EMPLOYEE"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || '' })
                  }}
                />
              </Grid>
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                disabled={!headers.company}
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!Object.values(headers).some(value => value !== '' && value !== null) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setShowTable(false)
                    setState({ ...state, tableKey: JSON.stringify(defaultHeaders) })
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem' }}>
            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={tableColumns}
              reportParamName="employee_advanced_search"
              reportName='employee_advanced_search'
              tableTitle={''}
              transform={tableDataTransformation}
              callback={handleCallback}
              downloadFileName={'Employee_Advanced_Search'}
              initialState={{}}
            />
          </div>
        )}
      </div>
    </div>
  )
}

